import { twMerge } from '@/lib/classname/twMerge'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { InfoCard } from '@/ui/cards/info-card/InfoCard'
import type { ExceptionalDate } from '@gql-generated/graphql'
import { formatExceptionalDate } from '../../../services/pointOfSale.formatting'
import { OpeningHoursIntervals } from '../../point-of-sale-opening-hours-list/PointOfSaleOpeningHoursList'

type DisplayPointOfSaleExceptionalDatesAlertProps = {
  exceptionalDates: ExceptionalDate[]
  className?: string
}

export function PointOfSaleExceptionalDatesAlert({
  exceptionalDates,
  className,
}: DisplayPointOfSaleExceptionalDatesAlertProps): React.ReactElement | null {
  const { t, Trans } = useTranslation(['pointOfSale'])

  if (!exceptionalDates || exceptionalDates.length === 0) {
    return null
  }

  return (
    <InfoCard
      title={t('pointOfSale:exceptionalDates.title')}
      variant="info"
      className={className}
      content={
        <ul>
          {exceptionalDates.map((exceptionalDate) => (
            <li key={exceptionalDate.date}>
              <Trans
                i18nKey={`pointOfSale:exceptionalDates.${exceptionalDate.isClosed ? 'closed' : 'open'}`}
                values={{
                  dateText: exceptionalDate.date ? formatExceptionalDate(exceptionalDate.date) : '',
                }}
                components={{
                  openNode: (
                    <span
                      className={twMerge(
                        'font-bold',
                        exceptionalDate.isClosed ? 'text-error-fg' : 'text-success-fg',
                      )}
                    />
                  ),
                  dateNode: <span className="capitalize" />,
                }}
              />
              {!exceptionalDate.isClosed &&
                exceptionalDate.intervals &&
                exceptionalDate.intervals.length > 0 && (
                  <span className="ml-1">
                    <OpeningHoursIntervals intervals={exceptionalDate.intervals} />
                  </span>
                )}
            </li>
          ))}
        </ul>
      }
    />
  )
}
